export default {
  meta: {
    title: '附件资料'
  }
};
